if (!customElements.get('file-uploader')) {
  customElements.define(
    'file-uploader',
    class FileUploader extends HTMLElement {
      constructor() {
        super();
        this.uploader = Uploader({
          apiKey: this.dataset.api,
        });

        this.uploader
          .open({
            maxFileCount: 10,
            layout: 'inline',
            container: '#upload-io-container',
            showFinishButton: false,
            onUpdate: (files) => this.updateInput(files),
            editor: {
              images: {
                crop: false,
                preview: false,
              },
            },
          })
          .then(
            (files) => {
              this.updateInput(files);
            },
            (error) => {
              alert(error);
            }
          );
      }

      updateInput(files) {
        const fileUrls = files.map((x) => x.fileUrl);
        const sanitizedUrls = fileUrls.map((url) => url.replace(/\s/g, '%20'));
        document.querySelector('[data-file-url]').value = sanitizedUrls.join('\n');
        this.classList.toggle('has-files', files.length > 0);
      }
    }
  );
}
